// @ts-nocheck
import styled from 'styled-components';

export const ReportingInsightsItemsSelectionModalStyle = styled.div`
  .insightsSelectionModal {
    &__category {
      width: 100%;
      border-radius: 4px;
      border: 1px solid ${props => props.theme.uiColors.reportingBorderColor};
      margin-top: 16px;
    }
    &__categoryLabel {
      padding: 16px;
      border-bottom: 1px solid ${props => props.theme.uiColors.reportingBorderColor};
    }
  }
  .inputWithSymbol__inputContainer .inputWithSymbol__input {
    border: none !important;
  }
`;
